import { Footer } from 'element-ui'
import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
    mode: 'history',
   
    routes: [{
            path: '/',
            component: () =>
                import ('../views/layout.vue'),
            redirect: '/index',
            children: [{
                    path: '/index',
                    name: '/index',
                    component: () =>
                        import ('../views/index/index.vue')
                },
                {
                    path: '/solution',
                    name: 'solution',
                    component: () =>
                        import ('../views/solution/solution.vue')
                },
                {
                    path: '/cooperation',
                    name: 'cooperation',
                    component: () =>
                        import ('../views/cooperation/cooperation.vue')
                },
                {
                    path: '/mediaIndex',
                    name: 'mediaIndex',
                    redirect: '/mediaInformation',
                    component: () =>
                        import ('../views/mediaInformation/mediaIndex.vue'),
                    children: [{
                            path: '/mediaInformation',
                            name: 'mediaInformation',
                            component: () =>
                                import ('../views/mediaInformation/mediaInformation.vue'),
                            meta: {
                                title: '媒体资讯'
                            }
                        },
                        {
                            path: '/informationlist',
                            name: 'informationlist',
                            component: () =>
                                import ('../views/mediaInformation/informationlist.vue'),
                            meta: {
                                title: '企业资讯列表'

                            }
                        },
                        {
                            path: '/videodatalist',
                            name: 'videodatalist',
                            component: () =>
                                import ('../views/mediaInformation/videodatalist.vue'),
                            meta: {
                                title: '视频资料列表'

                            }
                        },
                        {
                            path: '/enterpriseimagelist',
                            name: 'enterpriseimagelist',
                            component: () =>
                                import ('../views/mediaInformation/enterpriseimagelist.vue'),
                            meta: {
                                title: '企业形象列表'

                            }
                        },
                        {
                            path: '/sociallovelist',
                            name: 'sociallovelist',
                            component: () =>
                                import ('../views/mediaInformation/sociallovelist.vue'),
                            meta: {
                                title: '社会爱心列表'

                            }
                        },
                        {
                            path: '/businessdatalist',
                            name: 'businessdatalist',
                            component: () =>
                                import ('../views/mediaInformation/businessdatalist.vue'),
                            meta: {
                                title: '商业资料列表'

                            }
                        },
                        {
                            path: '/informationcontent/:id',
                            name: 'informationcontent',
                            component: () =>
                                import ('../views/mediaInformation/informationcontent.vue'),
                            meta: {
                                title: '企业资讯详情'
                            }
                        },
                        {
                            path: '/industrycontent/:id',
                            name: 'industrycontent',
                            component: () =>
                                import ('../views/mediaInformation/industrycontent.vue'),
                            meta: {
                                title: '行业动态详情'
                            }
                        },
                        {
                            path: '/videocontent/:id',
                            name: 'videocontent',
                            component: () =>
                                import ('../views/mediaInformation/videocontent.vue'),
                            meta: {
                                title: '视频资料详情'
                            }
                        },
                        {
                            path: '/enterprisecontent/:id',
                            name: 'enterprisecontent',
                            component: () =>
                                import ('../views/mediaInformation/enterprisecontent.vue'),
                            meta: {
                                title: '企业形象详情'
                            }
                        },
                        {
                            path: '/sociallovecontent/:id',
                            name: 'sociallovecontent',
                            component: () =>
                                import ('../views/mediaInformation/sociallovecontent.vue'),
                            meta: {
                                title: '社会爱心详情'
                            }
                        },
                        {
                            path: '/businessdatacontent/:id',
                            name: 'businessdatacontent',
                            component: () =>
                                import ('../views/mediaInformation/businessdatacontent.vue'),
                            meta: {
                                title: '商业资料详情'
                            }
                        },

                    ]
                },
                {
                    path: '/aboutusindex',
                    name: 'aboutusindex',
                    redirect: 'aboutUs',
                    component: () =>
                        import ('../views/aboutUs/aboutusindex.vue'),
                    children: [{
                            path: '/aboutUs',
                            name: 'aboutUs',
                            component: () =>
                                import ('../views/aboutUs/aboutUs.vue'),
                            meta: {
                                title: '关于我们'
                            }
                        },
                        {
                            path: '/honorQualification/:id',
                            name: 'honorQualification',
                            component: () =>
                                import ('../views/aboutUs/honorQualification.vue'),
                            meta: {
                                title: '荣誉资质详情'
                            }
                        }
                    ]
                },

            ]


        },





    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js